<script setup>

const props = defineProps({
  data: Object,
})
</script>

<template>
  <div class="row flex-start full-width column-mobile" :class="[props.data.margin, {'reverse-mobile': props.data.mobile_swap_columns}]">
    <template v-for="text in props.data.text">
      <div class="grid-cell" v-html="text"></div>
    </template>
  </div>
</template>

<style scoped lang="scss">
.column-mobile:deep(img) {
  @include smd {
    width: 100%;
    height: auto;
  }
}

.reverse-mobile {
  @include smd {
    flex-direction: column-reverse !important;
  }
}
</style>
